"use client";

import React, { useEffect, useState } from "react";
import Icon from "@/components/icons/Icons";
import { useIsMobile } from "@/utils/useIsMobile";
import { apiPost } from "@/utils/apiClient";
import CustomModal from "@/components/modal/CustomModal";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { closeKeywordModal } from "@/redux/features/KeywordModal/keywordSlice";

type KeywordData = {
  [key: string]: {
    title: string;
    content: string;
  };
};

export default function KeywordContentModal() {
  const [data, setData] = useState<KeywordData>({});
  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    dispatch(closeKeywordModal());
    setData({});
  };
  const dispatch = useDispatch();
  const { isOpen, modalKey } = useSelector((state: RootState) => state.keywordModal);

  const isMobile = useIsMobile();

  useEffect(() => {
    if (isOpen && modalKey) {
      fetchAllKeywords(modalKey);
    }
  }, [isOpen, modalKey]);

  const fetchAllKeywords = async (keys: string) => {
    setLoading(true);

    try {
      const res = await apiPost("web/getKeywordContent", { action: "getKeywordContent", url: keys });
      if (!res.status || res.status === 0) throw new Error("Something went wrong");
      const results: KeywordData = {
        [keys]: {
          title: res.title,
          content: res.content,
        },
      };
      setData(results);
    } catch (error) {
      console.error("Something went wrong", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CustomModal isOpen={isOpen} showCloseButton={isMobile} useDragToClose onClose={closeModal} maxSize="max-w-500" className="relative bg-white rounded-t-4xl xs:rounded-4xl pt-0 p-5 sm:p-6">
        {!isMobile && (
          <button onClick={closeModal} className="w-6 h-6 shadow-lg rounded-full absolute top-0 right-0 translate-x-1/4 -translate-y-1/4 bg-white inline-flex items-center justify-center" aria-label="Close">
            <Icon.popupCloseIcon />
          </button>
        )}

        {loading ? (
          <p className="text-sm text-gray-500">Loading...</p>
        ) : (
          <div className="space-y-6 text-sm text-[#363636] leading-relaxed overflow-y-auto scrollbar-sm max-h-[60vh] pr-2.5">
            {Object.entries(data).map(([key, value], index) => (
              <div key={key} className="mb-6 first-of-type:mb-0">
                <p className={`font-semibold mb-1 ${index === 0 ? "text-2xl" : "text-xl"}`}>{value.title}</p>
                <div className="font-medium text-base" dangerouslySetInnerHTML={{ __html: value.content }} />
              </div>
            ))}
          </div>
        )}
      </CustomModal>
    </>
  );
}
